import { authToken, teladocApi } from '@td/api';
import { camelCase, mapKeys } from 'lodash';

const TOKEN = authToken.get();

export const fetchOrganizationsByName = async (name) => {
  return await teladocApi.get(`/v1/organizations/search`, { q: name }, TOKEN)
    .then(response => {
      return response.data.data;
    }).catch(error => {
      console.log(error);
      return null;
    });
};

export const fetchOrganizationById = async (id) => {
  return await teladocApi.get(`/v1/organizations/${id}`, null, TOKEN)
    .then(response => {
      return response.data.data;
    }).catch((error) => {
      console.log(error);
      return null;
    });
};

export const fetchOrganizationParentById = async (id) => {
  return await teladocApi.get(`/v1/organizations/${id}/parent`, null, TOKEN)
    .then(response => {
      return response.data.data;
    }).catch((error) => {
      console.log(error);
      return null;
    });
};

export const fetchOrganizationChildrenById = async (id) => {
  return await teladocApi.get(`/v1/organizations/${id}/children`, null, TOKEN)
    .then(response => {
      return response.data.data;
    }).catch(error => {
      console.log(error);
      return null;
    });
};

export const fetchVendorProgramCategories = async () => {
  return await teladocApi.get(`/v1/lists/TASKVENDOR`, null, TOKEN)
    .then(response => {
      return response.data.data.map(category => mapKeys(category,
        (value, key) => camelCase(key)));
    }).catch(error => {
      console.log(error);
      return [];
    });
};

export const fetchVendorPoints = async () => {
  return await teladocApi.get(`/v4/vendor_points/`, null, TOKEN)
    .then(({ data }) => {
      return data.vendor_points.map(vendorPoint => mapKeys(vendorPoint,
        (value, key) => camelCase(key)));
    }).catch(error => {
      console.log(error);
      return [];
    });
};
